import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

const STORAGE_KEY = "kspb_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, opts = {}) => {
    const line = {
      product_id: product.id,
      slug: product.slug,
      name: product.name,
      image_url: product.image_url,
      price: product.price || 0,
      quantity: opts.quantity || 1,
      subscription: opts.subscription || "none",
      installation: !!opts.installation,
      monthly_subscription: product.monthly_subscription || 0,
      yearly_subscription: product.yearly_subscription || 0,
      installation_charge: product.installation_charge || 0,
      vehicle_type: opts.vehicle_type || "",
      is_quote_only: !product.price,
    };
    setItems((prev) => {
      const idx = prev.findIndex(
        (i) => i.product_id === line.product_id && i.subscription === line.subscription && i.installation === line.installation
      );
      if (idx >= 0) {
        const next = [...prev];
        next[idx].quantity += line.quantity;
        return next;
      }
      return [...prev, line];
    });
  };

  const updateQuantity = (index, q) => {
    setItems((prev) => prev.map((it, i) => (i === index ? { ...it, quantity: Math.max(1, q) } : it)));
  };

  const removeItem = (index) => {
    setItems((prev) => prev.filter((_, i) => i !== index));
  };

  const clear = () => setItems([]);

  const totals = items.reduce(
    (acc, it) => {
      const price = it.price * it.quantity;
      const install = it.installation ? it.installation_charge * it.quantity : 0;
      const sub =
        it.subscription === "monthly"
          ? it.monthly_subscription * it.quantity
          : it.subscription === "yearly"
          ? it.yearly_subscription * it.quantity
          : 0;
      acc.subtotal += price;
      acc.installation += install;
      acc.subscription += sub;
      acc.count += it.quantity;
      return acc;
    },
    { subtotal: 0, installation: 0, subscription: 0, count: 0 }
  );

  const gst = Math.round((totals.subtotal + totals.installation) * 0.18);
  const total = totals.subtotal + totals.installation + totals.subscription + gst;

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQuantity, removeItem, clear, totals, gst, total }}
    >
      {children}
    </CartContext.Provider>
  );
};
